<div class="event-participants">
  <h2 class="event-participants__title">{{ title | translate }}</h2>
  <div class="event-participants__list">
    <mec-event-participants-item
      [participant]="participant"
      *ngFor="let participant of participants"
    ></mec-event-participants-item>
  </div>
</div>
